import React, { PureComponent } from 'react';
import './App.css';

import { withStyles, withWidth } from '@material-ui/core';
import { compose } from 'recompose';

import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Content from './components/Content';

require('typeface-roboto-mono');

const styles = (theme) => ({
  root: {
    backgroundColor: '#1E2122',
    display: 'flex'
  },
  '@global': { // set up the global scroll bar style
    '*::-webkit-scrollbar': {
      width: '0.4em'
    },
    '*::-webkit-scrollbar-track': {
      '-webkit-box-shadow': 'inset 0 0 6px rgba(0, 0, 0, 0.00)'
    },
    '*::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(255, 255, 255, .5)',
      borderRadius: '10px',
      boxShadow: '0 0 6px rgba(0, 0, 0, .5)'
    }
  }
})

class App extends PureComponent {
  state = {
    drawerOpened: false,
    duration: 'day'
  }

  componentDidUpdate(prevProps) {
    // initialize drawerOpened when exit from xs or sm
    if (this.props.width !== 'xs' && this.props.width !== 'sm') {
      if (prevProps.width === 'xs' || prevProps.width === 'sm') {
        this.setState({ drawerOpened: false });
      }
    }
  }

  render() {
    return (
      <div className={`App ${this.props.classes.root}`}>
        <Header onMenuClicked={() => {
          if (this.props.width === 'xs' || this.props.width === 'sm') {
            this.setState({ drawerOpened: true });
          }
        }} />
        <Sidebar
          open={this.state.drawerOpened}
          onClose={() => this.setState({ drawerOpened: false })}
          duration={this.state.duration}
          onDurationChanged={duration => this.setState({ duration })}
        />
        <Content duration={this.state.duration} />
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withWidth()
)(App);
